// @ts-nocheck
import React from 'react';
import { compose } from '../../core';

import { withApollo } from '@apollo/client/react/hoc'
import { ALL_MEETING } from '../graphql/AllMeeting.gql';
import FutureMeetingView from '../components/FutureMeetingView';
import moment from 'moment-timezone';
const FutureMeetingContainer = props => {
  const { client, me, history, filteritem, newlyCreatedMeeting, setNewlyCreatedMeeting } = props
  const [meetingList, setMeeting] = React.useState([])
  const [loading, setloading] = React.useState(false);
  const [onFilterList, setOnFilterlist] = React.useState(false)

  const allMeetingList = async (filterData) => {
    setloading(true)
    if (filterData?.pagination_value) {
      setOnFilterlist(true)
    }
    else {
      setOnFilterlist(false)
    }
    let weekendDate = new Date(moment().format())
    let dif = 6 - weekendDate.getDay()
    weekendDate.setDate(weekendDate.getDate() + dif)
    let IsoWeekendDate = moment.utc(moment(weekendDate).endOf('day'))
    const { data } = await client.query({
      query: ALL_MEETING,
      variables: { ...filterData, orderBy: ['when'], when_Gt: IsoWeekendDate },
      fetchPolicy: 'network-only'
    });
    if (data?.allMeetings) {
      setloading(false)
      setMeeting(data?.allMeetings)
    }
  }

  React.useEffect(() => {
    if (me) {
      let selected_Data = JSON.parse(localStorage.getItem("one_on_one_filter"))
      if (selected_Data == null) {
        allMeetingList({ nextMeeting_Isnull: true, offset: 0, first: 20 })
      }
    }
    else if (me === null) {
      history.push('/user/login')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me])

  React.useEffect(() => {
    try {
      if (newlyCreatedMeeting && meetingList.hasOwnProperty("edges")) {
        let isExist = meetingList?.edges?.length && meetingList.edges.find(({ node }) => node.id === newlyCreatedMeeting.id)
        let weekendDate = new Date(moment().format())
        let dif = 6 - weekendDate.getDay()
        weekendDate.setDate(weekendDate.getDate() + dif)
        let IsoWeekendDate = moment.utc(moment(weekendDate).endOf('day'))
        if (!isExist && moment(newlyCreatedMeeting.event).isSameOrAfter(IsoWeekendDate)) {
          let updatedList = {
            ...meetingList,
            edges: [
              { node: newlyCreatedMeeting },
              ...(Array.isArray(meetingList.edges) ? meetingList.edges : [])
            ].sort((a, b) => {
              const dateA = moment(a.node.event);
              const dateB = moment(b.node.event);
              return dateA.valueOf() - dateB.valueOf();
            }),
          };
          setMeeting(updatedList)
        }
        setNewlyCreatedMeeting(null)
      }
    } catch (error) {
      console.error("Error updating list")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newlyCreatedMeeting, meetingList])

  React.useEffect(() => {
    if (filteritem) {
      allMeetingList({ nextMeeting_Isnull: true, ...filteritem, offset: 0, first: 20 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteritem])

  const PaginantionCall = (value) => {
    if (value) {
      allMeetingList({ nextMeeting_Isnull: true, ...filteritem, ...value, first: 20 })
    }
    else {
      allMeetingList({ nextMeeting_Isnull: true, offset: 0, first: 20 })
    }
  }

  return (
    <>
      <FutureMeetingView {...props} allMeetings={meetingList} onfilter={(e) => allMeetingList(e)} loading={loading} setloading={(e) => setloading(e)} onPaginantion={e => PaginantionCall(e)} filteritem={filteritem} onFilterList={onFilterList}></FutureMeetingView>
    </>
  );
};

export default compose(withApollo)(FutureMeetingContainer);